import React from "react";
import NodeGlyph from "../revenue-path/NodeGlyph";

const ICP = [
  "Personal trainers",
  "Coaches",
  "Beauty professionals",
  "Wellness providers",
  "Local service businesses",
  "Solo operators with repeatable offers",
];

/** ICP / "who it's for" — speaks to service operators, trainers first, without
 *  narrowing the site too far. */
export default function IcpSection() {
  return (
    <section
      data-testid="icp-section"
      className="bg-sand-100 px-5 sm:px-6 md:px-10 py-16 sm:py-20 md:py-24"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-12 gap-8 lg:gap-12 items-start">
          <div className="lg:col-span-6 reveal">
            <p className="eyebrow">Who It&rsquo;s For</p>
            <h2
              data-kinetic
              className="font-display mt-4 sm:mt-5 text-3xl sm:text-4xl md:text-5xl lg:text-[3rem] leading-[1.06] tracking-[-0.02em] font-semibold text-ink"
            >
              Built for service businesses that{" "}
              <span className="italic font-normal text-ink-muted">
                cannot afford slow follow-up.
              </span>
            </h2>
            <p className="mt-5 sm:mt-6 text-base md:text-lg text-ink-muted leading-relaxed">
              The Modern Exit is built for operators who already have skill,
              demand, and client relationships — but the backend is too manual.
            </p>
            <p className="mt-4 text-[14.5px] sm:text-[15px] text-ink-muted leading-relaxed">
              For trainers, the leak usually happens between the DM,
              consultation, booking, payment, and follow-up.
            </p>
          </div>

          <div className="lg:col-span-6 reveal">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
              {ICP.map((item, idx) => (
                <div
                  key={item}
                  data-testid={`icp-item-${idx}`}
                  className="flex items-center gap-3 border border-sand-300 bg-sand-50 p-5 transition-colors hover:border-clay"
                >
                  <NodeGlyph state="healthy" size={18} className="shrink-0" />
                  <span className="font-display text-[15px] sm:text-base font-medium tracking-tight text-ink leading-snug">
                    {item}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
